<template>
  <div>
    <el-container>
      <el-main>
        <el-form ref="form" v-if="!is_show" label-width="80px" >
          <el-input type="textarea" v-model="form.private_key" :rows="10" placeholder="请输入私钥解密"></el-input>
          <el-button type="primary" class="button" @click="doSubmit">提交</el-button>
        </el-form>
        
        <el-card v-if="is_show">
          <el-row>
            <el-col :span="4">域名</el-col>
            <el-col :span="8">{{ account ? account.domain : '' }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="4">帐号</el-col>
            <el-col :span="8">{{ account ? account.account : '' }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="4">类型</el-col>
            <el-col :span="8">{{ account ? account.cate : '' }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="4">密码</el-col>
            <el-col :span="8">{{ password || '' }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="4">备注</el-col>
            <el-col :span="8">{{ account ? account.remark : ''}}</el-col>
          </el-row>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import JSEncrypt from 'jsencrypt'

var save_private_key = 'private_wechat_key';

export default {
  data() {
    return {
      token: '',
      account: null,
      form: {
        private_key: localStorage.getItem(save_private_key) || ''
      },
      password: '',
      is_show: localStorage.getItem(save_private_key) || false
    }
  },
  methods: {
    getAccount() {
      this.token = this.$route.query.token || '',
      this.form.private_key = localStorage.getItem(save_private_key);

      var loading = this.$loading({
        lock: true,
        text: '读取中...',
        spinner: 'el-icon-loading',
        background: 'hsla(0,0%,100%,.9)',
      });

      this.$ajax({
        url: '/accounts/token',
        data: {
          token: this.token
        },
        type: 'POST',
      }).then((resp) => {
        loading.close()
        this.account = resp.data;

        if(this.form.private_key) {
          this.decryptPass(save_private_key, this.form.private_key, this.account);
        }
      });
    },
    decryptPass(save_key, value, account, is_save) {
      let password = this.decrypt(value, account.password);

      if(!password) {
        localStorage.removeItem(save_key);
        return this.$util.msg('解密失败，请提供正确的密钥', 'error');
      }

      if(is_save) {
        localStorage.setItem(save_key, value);
      }

      this.is_show = true;
      this.password = password
    },
    decrypt(private_key, pass) {
      let decrypt = new JSEncrypt(),
          password = '';

      decrypt.setPrivateKey(private_key);

      return decrypt.decrypt(pass);
    },
    doSubmit() {
      return this.$confirm('是否信任此浏览器，信任后，将不在输入密钥',"提示", {
        confirmButtonText: "信任",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.decryptPass(save_private_key, this.form.private_key, this.account, true);
      }).catch(() => {
        this.decryptPass(save_private_key, this.form.private_key, this.account, false);
      });
    },

  },
  mounted() {
    this.getAccount();
  },
}
</script>
<style>
  #app {
    background-color: #ffffff;
  }
  .button{
    width: 100%;
    margin-top: 40px;
  }

  .el-row .el-col{
    font-size: 16px;
    margin-top: 15px;
  }
</style>